import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const ACTIVE_STATUSES = ['open', 'in_progress'];

export async function userHasActiveSupportTicket(uid) {
  const q = query(
    collection(db, 'supportTickets'),
    where('authorUid', '==', uid),
    where('status', 'in', ACTIVE_STATUSES),
    limit(1),
  );
  const snap = await getDocs(q);
  return !snap.empty;
}
